import { ref } from 'vue'

const isOpen = ref(false)
type ConfirmOptions = {
    title: string
    body: string
    type: 'normal' | 'destructive'
}

const options = ref<ConfirmOptions>({ title: '', body: '', type: 'normal' })
let resolvePromise: ((value: boolean) => void) | null = null

export function useConfirm() {
    function confirm(opts: ConfirmOptions = { title: '', body: '', type: 'normal' }) {
        options.value = opts
        isOpen.value = true
        return new Promise((resolve) => {
            resolvePromise = resolve
        })
    }

    function handleOk() {
        isOpen.value = false
        resolvePromise?.(true)
    }

    function handleCancel() {
        isOpen.value = false
        resolvePromise?.(false)
    }

    return { isOpen, options, confirm, handleOk, handleCancel }
}
